export default "__VITE_PUBLIC_ASSET__6b3d7c71__"